<template>
    <b-navbar id="navbar">
        <template slot="brand">
            <a href="/"><img src="images/DemandScale-Marketing-Logo.png" alt="DemandScale" class="logo"></a>
        </template>
        <template slot="start" v-if="!hideMenu">
            <div class="navigation-links" style="display: inline-flex;">
                <a href="dashboard.html" class="navigation-link">{{$t('campaigns')}}</a>
                <a href="reports.html" class="navigation-link">{{$t('reports')}}</a>
                <b-navbar-dropdown :label="$t('OPTIMIZATION')" class="navigation-link">
                    <a href="subsites.html" class="navigation-link">{{$t('subsites')}}</a>
                    <a href="sources.html" class="navigation-link">{{$t('sources')}}</a>
                    <a href="suppression_lists.html" class="navigation-link">{{$t('suppression')}}</a>
                    <a href="pie_optimization.html" class="navigation-link">{{$t('pie')}}</a>
                </b-navbar-dropdown>
                <a href="invoices.html" class="navigation-link">{{$t('invoices')}}</a>
                <a href="pricing.html" class="navigation-link">{{$t('pricing')}}</a>
                <a href="faq.html" class="navigation-link">{{$t('faq')}}</a>
                <div style="width:200px;padding:22px 0 0 20px">
                    <b-autocomplete
                        v-model="campaign_search_term"
                        :data="campaign_search_results"
                        placeholder="Search"
                        icon="magnify"
                        clearable
                        @typing="searchCampaign"
                        @select="selectCampaign">
                        <template slot-scope="props">{{ props.option.name }} - {{ props.option.offer_id }}</template>
                    </b-autocomplete>
                </div>
            </div>
        </template>
        <template slot="end" v-if="!hideMenu">
            <b-navbar-dropdown :label="user.name" right>
                <b-navbar-item href="user_profile.html">{{$t('user_profile')}}</b-navbar-item>
                <b-navbar-item href="change_password.html">{{$t('change_password')}}</b-navbar-item>
                <b-navbar-item href="email_preferences.html">{{$t('manage_email_preferences')}}</b-navbar-item>
                <b-navbar-item href="support.html">{{$t('support')}}</b-navbar-item>
                <b-navbar-item href="logout.html">{{$t('log_out')}}</b-navbar-item>
            </b-navbar-dropdown>
        </template>
    </b-navbar>
</template>

<style>
    #navbar {
        min-height: 80px;
        max-height: 80px;
    }
    img.logo {
        margin-top: 22px;
        min-width: 159px;
        max-width: 159px;
        min-height: 40px;
        max-height: 40px;
        margin-left: 40px;
        margin-right: 40px;
        vertical-align: middle;
    }
    .dropdown-content {
        min-width: 800px;
    }
    .navbar-link:not(.is-arrowless) {
        color: #070f1a;
    }
    .navbar-start {
        width: 100%;
    }
    .navbar-end {
        width: 240px;
    }
    .navbar-burger {
        margin-top: 15px;
    }
    .navigation-links {
        margin: auto;
        display: inline-block;
    }
    .navigation-link {
        margin: auto;
        padding: 32px 12px;
        opacity: 1;
        color: #070f1a;
        font-size: 13px;
        font-weight: 600;
        font-family: 'Arial', sans-serif;
        letter-spacing: 1.0px;
        text-transform: uppercase;
    }
    .navigation-link:hover {
        opacity: 0.6;
        text-decoration: none;
    }
</style>

<style lang="scss">
    @import "~bulma/sass/utilities/_all";
    $primary: #0014ef;
    $primary-invert: findColorInvert($primary);
    @import "~bulma";
    @import "~buefy/src/scss/buefy";
</style>

<script>
    import session from '../session'
    import common from "@/common";
    import debounce from 'lodash/debounce'

    const model = {
        user: {
            name: null
        },
        is_fetching: false,
        campaign_search_term: null,
        campaign_search_results: []
    };

    function getUserSuccessHandler(responseData) {
        model.user.name = responseData;
    }

    function errorHandler() {
    }

    export default {
        props: {
            hideMenu: Boolean
        },
        methods: {
            searchCampaign: debounce(function (searchTerm) {
                if (!searchTerm) {
                    common.clearArray(model.campaign_search_results);
                    return;
                }
                model.is_fetching = true;
                function autoCompleteSuccessHandler(response) {
                    common.clearArray(model.campaign_search_results);
                    response.campaigns.forEach((item) => model.campaign_search_results.push(item));
                    model.is_fetching = false;
                }
                function autoCompleteErrorHandler() {
                    common.clearArray(model.campaign_search_results);
                    model.is_fetching = false;
                }
                session.get(`campaign_search?search_term=${searchTerm}`, autoCompleteSuccessHandler, autoCompleteErrorHandler, []);
            }, 250),
            selectCampaign: function (offer) {
                session.navigateToPage('campaign.html?offer_id=' + offer.offer_id);
            }
        },
        created () {
            if (!this.hideMenu) {
                session.get('fullname', getUserSuccessHandler, errorHandler, []);
            }
        },
        data: function () {
            return model;
        }
    }
</script>
